export default "__VITE_ASSET__Ez$cmh8Y__"